import Helper from '@/resources/Helper';
import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';

const tableName = 'booking';

const functions = {
    async get() {
        await this.sync();

        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async save(value) {
        const currentData = await this.get();
        let operation = 'add';

        // Stamp Update Time
		value.appointment['timestamp'] = Helper.getClientTime();

        if (currentData && currentData.content.filter(x => x.keyDate === value.keyDate).length > 0) {
            operation = 'update';

            for (let dateIndex = 0; dateIndex < currentData.content.length; dateIndex++) {
                if (currentData.content[dateIndex].keyDate === value.keyDate) {
                    if (value.appointment.key) {
                        // Update Existing
                        const appointmentIndex = currentData.content[dateIndex].appointment.findIndex(x => x.key === value.appointment.key);

                        if (appointmentIndex > -1) {
                            currentData.content[dateIndex].appointment[appointmentIndex] = value.appointment;
                        }
                    } else {
                        // New Booking
                        value.appointment['key'] = Helper.generateGUID();
                        currentData.content[dateIndex].appointment.push(value.appointment);
                    }
                    
                    break;
                }
            }
        } else {
            const data = {
                keyDate: '',
                appointment: []
            };

            value.appointment['key'] = Helper.generateGUID();

            data.keyDate = value.keyDate;
            data.appointment.push(value.appointment);

            currentData.content.push(data);
        }

		// Setup Current IndexedDB
		await DBEngine.replaceRecord(tableName, currentData.content, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, operation, value);
    },
    async delete(value) {
        const currentData = await this.get();
        let operation = 'delete';

        if (currentData && currentData.content.filter(x => x.keyDate === value.keyDate).length > 0) {
            for (let dateIndex = 0; dateIndex < currentData.content.length; dateIndex++) {
                if (currentData.content[dateIndex].keyDate === value.keyDate) {
                    const appointmentIndex = currentData.content[dateIndex].appointment.findIndex(x => x.key === value.appointment.key);
                    currentData.content[dateIndex].appointment.splice(appointmentIndex, 1);
                    
                    break;
                }
            }
        }

		// Setup Current IndexedDB
		await DBEngine.replaceRecord(tableName, currentData.content, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, operation, value);
    }
}

export default functions;